import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetInvoiceList({ commit }, list) {
    return new Promise((resolve) => {
      axios({
        url: list.url || "/invoice/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page,
          company_name: list.search ? `*${list.search}*` : "",
          per_page: list.perPage ? list.perPage : "",
          paid: list.paid ? list.paid : "",
          company_uuid: list.company_uuid,
        },
        method: "GET",
      }).then((res) => {
        resolve(res.data.payload);
      });
    });
  },

  DownloadInvoice({ commit }, id) {
    return new Promise((resolve) => {
      axios({
        url: `/invoice/${id}`,
        method: "GET"
      }).then((res) => {
        resolve(res.data.payload);
      });
    });
  },

  AddInvoice({ commit }, invoice) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/invoice",
        data: invoice.invoice,
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

// mutations
const mutations = {
  setUser: (state, user) => {
    state.user = user;
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
